module.exports = "<mat-toolbar color=\"primary\">Bazahl Code Generator</mat-toolbar>\n\n<app-datainput></app-datainput>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main